import { OffChainVaultStats, PeriodApys } from 'src/@types/vaults';
import { S3_BUCKET_VELOCITY_PUBLIC, QUOTE_ASSET_SYMBOL } from '../constants';

export const VAULT_CONFIGS_REMOTE_URL = `${S3_BUCKET_VELOCITY_PUBLIC}/vaults/configs.json`;

export const VAULT_TERMS_AND_CONDITIONS_DO_NOT_SHOW_AGAIN_KEY =
	'vaultTermsAndConditionsDoNotShowAgain';

export const FEES_PLACEHOLDER = 'fees_placeholder';
export const MANAGEMENT_FEE_PLACEHOLDER = 'management_fee_placeholder';
export const PERIOD_PLACEHOLDER = 'period_placeholder';

export type Placeholders =
	| typeof FEES_PLACEHOLDER
	| typeof MANAGEMENT_FEE_PLACEHOLDER
	| typeof PERIOD_PLACEHOLDER;

export const CAPACITY_WARNING_THRESHOLD = 80;
export const CAPACITY_CRITICAL_THRESHOLD = 99;

export const DEFAULT_PERIOD_APY: keyof PeriodApys = '90d';

export const VAULT_TEMP_APY_LABEL = 'Target APY';
export const VAULT_TARGET_APY_TOOLTIP_CONTENT =
	'This vault is under 30 days old, hence the target APY set by the vault manager is used instead.';
export const VAULT_APY_TOOLTIP_CONTENT = `APY is estimated based on the vault's change in share price over the time period, inclusive of any vault fees.`;
export const VAULT_APY_LABEL = 'APY';

export const VAULT_NOTIONAL_GROWTH_STRATEGY_INFO_TEXT = `This vault is a notional growth vault, focusing on increasing the ${QUOTE_ASSET_SYMBOL} value of your deposits.`;

export const DEFAULT_OFF_CHAIN_STATS: OffChainVaultStats = {
	apys: {
		'7d': 0,
		'30d': 0,
		'90d': 0,
		'180d': 0,
		'365d': 0,
	},
	maxDrawdownPct: 0,
	numOfVaultSnapshots: 0,
	hasLoadedOffChainStats: false,
};
